module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABQAgMAAAAcvXEAAAAADFBMVEUAAABMTFlMR2RQRFvnLb6UAAAABHRSTlMAEwcOBQrAcwAAAQVJREFUOMvd1DFOBDEMBVCzoy1Tcgn66fcQ+zUUEaKm4gb4EtwBQk1NLpHjoMGyBTurnyJI0KyLKZ4izY/jRH5qV1Tk5uUEoTiIzPm/VXs63fc05Z7OS08bKusEPNpuS3nDQynvd8VKJQFHucJZqVwDYG0A6uDaPZBJI0Mks783y/AK3ea1z/OtZYXG3lhTZo2esYp2VS5cP9b1k7VhU3+kutVltYqzMK0yeYbt/LLOC2nML6nPDmsCMqnPJGnM7+DaPXAcysB5eW/chyc7IesWvA7fPcOpXEW7Kr/Usztvyq/R7oJUWaO/rCmzxrmxNlRSnwdSf1NJfc5IYybH1vqbOpahfgF1pBwMO65LXAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/fblogo.png
// module id = VDxY
// module chunks = 0